<p>control-sidebar works!</p>
